{
  "EMOJI": {
    "PLACEHOLDER": "Emoji ara",
    "NOT_FOUND": "Aramanızla eşleşen emoji yok",
    "REMOVE": "Kaldır"
  }
}
